module.exports = __webpack_public_path__ + "static/media/logo.c10be824.svg";